import { authGuard } from '@/features/auth/guards/authGuard.js'
import DevModeLayout from '@/features/devMode/DevModeLayout.vue'

export const devRoutes = [
  {
    path: 'dev-mode',
    component: DevModeLayout,
    beforeEnter: [authGuard],
    children: [
      {
        path: 'users-list',
        component: () => import('@/features/devMode/usersList/TestUsersList.vue'),
      },
      {
        path: 'endpoints',
        component: () => import('@/features/devMode/endpoints/EndpointsView.vue'),
      },
      {
        path: 'update-mobile-version',
        component: () => import('@/features/devMode/mobileVersion/UpdateMobileVersionView.vue'),
      },
      {
        path: 'user-info',
        component: () => import('@/features/devMode/userInfo/UserInfoView.vue'),
      },
    ],
  },
]
